<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">Transações para Câmbio</h1>
        </v-flex>
        <v-flex xs12>
          <div v-if="responsiblesLoaded == 'not_loaded'">Carregando beneficiários...</div>
          <div v-if="responsiblesLoaded == 'error'">Algo errado. Não foi possível carregar os beneficiários.</div>
          <div v-if="responsiblesLoaded == 'not_authorized'">Não foi possível carregar as beneficiários. Você não foi autorizado.</div>
          <div v-if="responsiblesLoaded == 'empty'">Não existem transferências em espera neste momento.</div>
          <transition name="fade">
            <v-card class="mb-3" style="border-radius: 10px;" v-if="responsiblesLoaded == 'ok' && bankAccountsLoaded == 'ok'">
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 sm7 py-0 pt-1>
                  </v-flex>
                  <v-flex xs12 sm5 py-0 text-xs-left text-sm-right pt-1>
                    <div class="font-weight-thin">Registros: {{responsibles.length}}</div>
                  </v-flex>
                  <v-flex xs12 pa-0>
                    <v-text-field v-model="responsiblesFilter" class="search-filter" append-icon="search"></v-text-field>
                  </v-flex>

                  <admin-account-item
                    @exchangeCreated="exchangeCreated"
                    :bank_accounts="bankAccounts"
                    :record="responsible"
                    v-for="responsible in responsibles" :key="responsible.ref"
                  />

                </v-layout>
              </v-container>
              <v-card-actions>
                <v-layout column>
                  <v-flex xs12>
                    <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style" >
                      EXIBIR MAIS
                    </v-btn>
                    <slot></slot>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import AdminExchangeAccountItem from "./AdminExchangeAccountItem"
import { BankAccountsApi } from '@/shared/BankAccountsApi'

export default {
  name: 'AdminExchangeByReceiver',
  components: { layout: LeftBarLayout, 'admin-account-item': AdminExchangeAccountItem },
  data: () => {
    return {
      navItems: [{ url: '/admin/exchange/list', title: 'Operações de Câmbio', icon: 'dashboard' }],
      bankAccounts: [],
      responsibles: [],
      showMoreBtn: false,
      bankAccountsLoaded: 'not_loaded',
      responsiblesLoaded: 'not_loaded',
      responsiblesFilter: ''
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadResponsibles()
    this.loadBankAccounts()
  },
  watch: {
  },
  methods: {
    exchangeCreated(record_exchange, exchange_data) {
      this.responsibles.splice(this.responsibles.findIndex(el => el.ref === this.createReference(record_exchange)), 1)
      if (this.responsibles.length === 0) {
        this.responsiblesLoaded = 'empty'
      }
    },
    loadBankAccounts() {
      this.bankAccountsLoaded = 'not_loaded'
      this.bankAccounts = []

      let fetchBankAccountsCallback = (bankAccountsResult) => {
        if (bankAccountsResult == 'error') {
          this.bankAccountsLoaded = 'error'
          return
        }

        if (bankAccountsResult == 'not_authorized') {
          this.bankAccountsLoaded = 'not_authorized'
          return
        }

        this.bankAccounts = bankAccountsResult
        this.bankAccountsLoaded = 'ok'
      }

      this.fetchBankAccounts(fetchBankAccountsCallback)
    },
    fetchBankAccounts(callback) {
      let fetchedBankAccounts = []

      let successCallback = (response) => {
        if (response.body.data) {
          if (response.body.data.length == 100) {
            fetchedBankAccounts = fetchedBankAccounts.concat(response.body.data)

            let last_id = response.body.data[response.body.data.length - 1]['id']
            BankAccountsApi.onlyGet(this, this.$root.urls.admin__user__bank_accounts, successCallback, errorCallback, { last_id: last_id })
            return
          } else {
            fetchedBankAccounts = fetchedBankAccounts.concat(response.body.data)
            callback(fetchedBankAccounts)
            return
          }
        } else {
          callback('error')
          return
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          callback('not_authorized')
          return
        } else {
          console.log('errorCallback', response)
          callback('error')
          return
        }
      }
      BankAccountsApi.onlyGet(this, this.$root.urls.admin__user__bank_accounts, successCallback, errorCallback, { not_exclusive: true });
    },
    createReference(item) {
      if(item.count == 1) return item.bank_transaction_ids[0];
      return item.receiver.id + item.company_id;
    },
    loadResponsibles() {
      let putReference = (item) => {
        item.ref = this.createReference(item)
        return item
      }
      let successCallback = (response) => {
        if (response.body.data) {
          this.responsibles = response.body.data.map(putReference);

          if (this.responsibles.length === 0) {
            this.responsiblesLoaded = 'empty'
          } else {
            this.responsiblesLoaded = 'ok'
          }
        } else {
          this.responsiblesLoaded = 'error'
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.responsiblesLoaded = 'not_authorized'
        } else {
          this.responsiblesLoaded = 'error'
        }
        console.log('errorCallback', response)
        debugger
      }

      this.responsiblesLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.admin__bank_transactions__for_exchange_by_receiver, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
.disable-events {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/AdminExchangeByReceiver.vue